import styles from '@/routes/home/components/HomeToast.module.scss'

type ToastTone = 'info' | 'success' | 'error'

type HomeToastProps = {
  toast: {
    message: string
    tone: ToastTone
  } | null
}

export default function HomeToast({ toast }: HomeToastProps) {
  return (
    <div className={styles.toastWrap} role="status" aria-live="polite">
      {toast && (
        <div
          className={[
            styles.toast,
            toast.tone === 'success' ? styles.toastSuccess : '',
            toast.tone === 'error' ? styles.toastError : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {toast.message}
        </div>
      )}
    </div>
  )
}
